import { createAjaxAction } from "../../../Common/_actions/AjaxAction";
import type { StoreProductPayload } from "../../_stores/Store/StoreProductStore";
import { EditStoreProduct } from "./StoreProductStoreActions";

export enum StoreVariantActionType {
  UpdateStoreVariant = 'STORE_VARIANT_UPDATE_STORE_VARIANT',
  IgnoreStoreVariant = 'STORE_VARIANT_IGNORE_STORE_VARIANT',
  UnignoreStoreVariant = 'STORE_VARIANT_UNIGNORE_STORE_VARIANT',
  UnsyncStoreVariant = 'STORE_VARIANT_UNSYNC_STORE_VARIANT',
  IgnoreAllStoreVariants = 'STORE_VARIANT_IGNORE_ALL_STORE_VARIANTS',
  UnignoreAllStoreVariants = 'STORE_VARIANT_UNIGNORE_ALL_STORE_VARIANTS',
  UnsyncAllStoreVariants = 'STORE_VARIANT_UNSYNC_ALL_STORE_VARIANTS',
}

/* eslint-disable @typescript-eslint/max-params */
export const UpdateStoreVariant = (
  storeType: string,
  storeProductId: number,
  variantId: number,
  productDesignId: number,
  productId: number,
  options: number[],
) => {
  const data = new FormData()
  
  data.append('id_product_design', String(productDesignId))
  data.append('id_product', String(productId))

  options.forEach(option => {
    data.append('options[]', String(option))
  })

  return createAjaxAction<{storeProduct: StoreProductPayload}>(StoreVariantActionType.UpdateStoreVariant, {
    url: 'ajax/api/user/stores/' + storeType + '/products/'+String(storeProductId)+'/variants/'+String(variantId)+'/update',
    method: 'POST',
    data,
    onSuccess: (response, dispatch) => {
      dispatch(EditStoreProduct(storeType, response.data.storeProduct))
    },
  });
}
/* eslint-enable @typescript-eslint/max-params */

export const IgnoreStoreVariant = (
  storeType: string,
  storeProductId: number,
  variantId: number,
) => {
  return createAjaxAction<{storeProduct: StoreProductPayload}>(StoreVariantActionType.IgnoreStoreVariant, {
    url: 'ajax/api/user/stores/' + storeType + '/products/'+String(storeProductId)+'/variants/'+String(variantId)+'/ignore',
    method: 'POST',
    onSuccess: (response, dispatch) => {
      dispatch(EditStoreProduct(storeType, response.data.storeProduct))
    },
  });
}

export const UnignoreStoreVariant = (
  storeType: string,
  storeProductId: number,
  variantId: number,
) => {
  return createAjaxAction<{storeProduct: StoreProductPayload}>(StoreVariantActionType.UnignoreStoreVariant, {
    url: 'ajax/api/user/stores/' + storeType + '/products/'+String(storeProductId)+'/variants/'+String(variantId)+'/unignore',
    method: 'POST',
    onSuccess: (response, dispatch) => {
      dispatch(EditStoreProduct(storeType, response.data.storeProduct))
    },
  });
}

export const UnsyncStoreVariant = (
  storeType: string,
  storeProductId: number,
  variantId: number,
) => {
  return createAjaxAction<{storeProduct: StoreProductPayload}>(StoreVariantActionType.UnsyncStoreVariant, {
    url: 'ajax/api/user/stores/' + storeType + '/products/'+String(storeProductId)+'/variants/'+String(variantId)+'/unsync',
    method: 'POST',
    onSuccess: (response, dispatch) => {
      dispatch(EditStoreProduct(storeType, response.data.storeProduct))
    },
  });
}

export const IgnoreAllStoreVariants = (
  storeType: string,
  storeProductId: number,
) => {
  return createAjaxAction<{storeProduct: StoreProductPayload}>(StoreVariantActionType.IgnoreStoreVariant, {
    url: 'ajax/api/user/stores/' + storeType + '/products/'+String(storeProductId)+'/variants/ignore-all',
    method: 'POST',
    onSuccess: (response, dispatch) => {
      dispatch(EditStoreProduct(storeType, response.data.storeProduct))
    },
  });
}

export const UnignoreAllStoreVariants = (
  storeType: string,
  storeProductId: number,
) => {
  return createAjaxAction<{storeProduct: StoreProductPayload}>(StoreVariantActionType.UnignoreStoreVariant, {
    url: 'ajax/api/user/stores/' + storeType + '/products/'+String(storeProductId)+'/variants/unignore-all',
    method: 'POST',
    onSuccess: (response, dispatch) => {
      dispatch(EditStoreProduct(storeType, response.data.storeProduct))
    },
  });
}

export const UnsyncAllStoreVariants = (
  storeType: string,
  storeProductId: number,
) => {
  return createAjaxAction<{storeProduct: StoreProductPayload}>(StoreVariantActionType.UnsyncStoreVariant, {
    url: 'ajax/api/user/stores/' + storeType + '/products/'+String(storeProductId)+'/variants/unsync-all',
    method: 'POST',
    onSuccess: (response, dispatch) => {
      dispatch(EditStoreProduct(storeType, response.data.storeProduct))
    },
  });
}
